export const UPDATELOADINGSTATUS = 'UPDATELOADINGSTATUS'

export const UPDATEDIRECTION = 'UPDATEDIRECTION'

export const UPDATEUSER = 'UPDATEUSER'

export const UPDATETITLE = 'UPDATETITLE'

export const UPDATECLIENT = 'UPDATECLIENT'



// WEBPACK FOOTER //
// ./src/store/mutations-types.js